<template>
  <div v-if="selectList.length" class="refer">

    <el-form
      :inline="true"
      ref="form"
      class="select-con refer-from"
    >
      <template v-for="(item, index) in selectList">
        <!-- 除了 (院校/教学点) 之外的 select -->
        <el-form-item 
          :label="item.title + '：'"
          v-if="item.type === 'select' && index < showAdvanced && item.requestKey != 'schoolId' && item.requestKey != 'stationId'"
          :key="item.title"
          class="change-label-calss"
        >
          <el-select
            v-model="requestForm[item.requestKey]"
            label="item.lable"
            placeholder="请选择"
            :multiple="item.multiple ? true : false"
            collapse-tags
            :filterable="item.isSearch"
            @change="item.change && item.change($event)"
            @input="$forceUpdate()"
            :disabled="item.disabled ? true : false"
          >
            <el-option
              v-for="(itemChild,index) in item.data"
              :key="index"
              :label="itemChild[item.label]"
              :value="itemChild[item.value]"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item 
          :label="item.title + '：'"
          v-if="item.type === 'inputInterval' && index < showAdvanced"
          :key="item.title"
          class="change-label-calss input-interval"
        >
        <el-input v-model="requestForm[item.requestKey]" placeholder="0" @input="$forceUpdate()"></el-input> - <el-input @input="$forceUpdate()" v-model="requestForm[item.requestKeySecond]" placeholder="59"></el-input>
        </el-form-item>
        <!-- 院校列表 -->
        <el-form-item 
          :label="item.title + '：'"
          v-if="item.type === 'select' && index < showAdvanced && item.requestKey == 'schoolId'"
          :key="item.title"
          class="change-label-calss"
        >
          <el-select
            v-model="requestForm[item.requestKey]"
            label="item.lable"
            placeholder="请选择"
            :multiple="item.multiple ? true : false"
            collapse-tags
            :filterable="item.isSearch"
            @change="item.change && item.change($event)"
            :disabled="roleType == 2"

          >
            <el-option
              v-for="itemChild in item.data"
              :key="itemChild[item.value]"
              :label="itemChild[item.label]"
              :value="itemChild[item.value]"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 教学点列表 -->
        <el-form-item 
          :label="item.title + '：'"
          v-if="item.type === 'select' && index < showAdvanced && item.requestKey == 'stationId'"
          :key="item.title"
          class="change-label-calss"
        >
          <el-select
            v-model="requestForm[item.requestKey]"
            label="item.lable"
            placeholder="请选择"
            :multiple="item.multiple ? true : false"
            collapse-tags
            :filterable="item.isSearch"
            @change="item.change && item.change($event)"
            :disabled="roleType == 3"
          >
            <el-option
              v-for="itemChild in item.data"
              :key="itemChild[item.value]"
              :label="itemChild[item.label]"
              :value="itemChild[item.value]"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- input 搜索表单 -->
        <el-form-item
          :label="item.title + '：'"
          v-if="item.type === 'input' && index < showAdvanced"
          :key="item.title"
          class="change-label-calss"
        >
          <el-input
            v-model="requestForm[item.requestKey]"
            :placeholder="item.placeholder"
            @input="$forceUpdate()"
          ></el-input>
        </el-form-item>

        <!-- 省/市 级联 -->
        <el-form-item 
          :label="item.title + '：'"
          v-if="item.type === 'cascader' && index < showAdvanced"
          :key="item.title"
          class="change-label-calss"
        >
          <el-cascader
              size="large"
              v-model="requestForm[item.requestKey]"
              :options="item.data"
              :props="{value: 'name', label: 'name', children: 'cityList'}"
              @change="changeCity($event, item.requestKey)"
          >
          </el-cascader>
        </el-form-item>
        <!-- 时间 搜索组件 -->
        <el-form-item
          :label="item.title + '：'"
          v-if="item.type === 'daterange' && index < showAdvanced"
          :key="item.title"
          class="change-label-calss dataAndTime"
        >
          <el-date-picker
            v-model="requestForm[item.requestKey]"
            type="daterange"
            align="center"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="item.pickerOptions"
            :clearable="true"
          >
          </el-date-picker>
        </el-form-item>

        <!-- 新增 ： 日期-时间格式 -->
        <el-form-item
          :label="item.title + '：'"
          v-if="item.type === 'datetimerange' && index < showAdvanced"
          :key="item.title"
          class="change-label-calss dataAndTime"
        >
          <el-date-picker
            v-model="requestForm[item.requestKey]"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="item.pickerOptions"
            align="center">
          </el-date-picker>
        </el-form-item>

      </template>
      <!-- 查询 button -->
      <el-form-item v-show="isAutoAssign" class="site-button" :class="selectList.length > 3 ? 'lang' : 'short'">
      </el-form-item>
      <el-form-item v-if="isAutoAssign" class="buttons" :class="selectList.length > 3 ? 'lang' : 'short'">
        <el-button
          class="query-btn"
          :type="colorType"
          round
          @click="search"
          plain
          >{{ queryBtnText }}</el-button
        >
        <el-button
          type="text"
          round
          @click="advancedSearch"
          v-if="selectList.length > 3 && showAdvanced === 3"
          >高级查询</el-button
        >
        <el-button
          type="text"
          round
          @click="closeAdvancedSearch"
          v-if="selectList.length > 3 && showAdvanced === 50"
          >收起</el-button
        >
      </el-form-item>
      <!-- <el-form-item v-show="isAutoAssign" class="site-button">
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
export default {
  name: "OtsRefer",
  props: {
    selectList: {
      type: Array,
      default: () => [],
    },
    requestForm: {
      type: Object,
      default: () => {},
    },
    queryBtnText: {
      type: String,
      default: '查询'
    }
  },
  data() {
    return {
      colorType: "primary",
      colorTypeNo: "",
      showAdvanced: 3,
      roleType : "",
    };
  },
  computed : {
    /* ** 评阅自动分配隐藏查询按钮 ** */
    isAutoAssign(){
      return this.$route.name !== 'autoAssign';
    },
  },
  methods: {
    /***********************************
     * @this 获取用户对应的权限(院校/教学点/系统)
     * @roleType 1 => 管理员 ; 2 => 院校 ; 3 => 教学点
     ***********************************/
    getUserRoleType(){
      this.mixin_getCommonInfo().then(res=>{
        this.$emit('roleType', res.roleType);
        this.roleType = res.roleType;
        if (this.requestForm) {
          if (res.roleType == 2) {
            this.requestForm.schoolId = res.schoolId;
          } else if(res.roleType == 3) {
            this.requestForm.stationId = res.stationId;
          }          
        }
      })
    },
    changeCity(e,attr){
      this.$emit("changeCity", e, attr);
    },
    search() {
      this.$emit("search");
      this.$event.$emit("setCurrentPage");
      this.colorType = "primary";
      this.colorTypeNo = "";
    },
    advancedSearch() {
      this.colorTypeNo = "primary";
      this.showAdvanced = 50;
    },
    closeAdvancedSearch() {
      this.showAdvanced = 3;
    },
  },
  mounted() {
      this.getUserRoleType();

      // examActivity
      if (this.$route.name == 'examActivity') this.showAdvanced = 4

  },
};
</script>

<style lang="less" scoped>

/deep/ .el-form-item__label {
  min-width: 80px;
  width: auto!important;
}

.dataAndTime {
  /deep/ .el-form-item__content{
    width: 260px;
  }
}

.query-btn {
  color: @c-006;
  border: 1px solid @c-006;
}
.select-con {
  background: #fff;
  position: relative;
  border-radius: 8px;
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: space-between;
}
.refer-from {
  padding: 20px 16px 0px 16px;
  border-bottom: 1px solid transparent;
  .el-form-item {
    margin-bottom: 20px;
  }
  /deep/ .el-form-item__label {
    padding-right: 4px !important;
  }
}
.change-label-calss /deep/ .el-form-item__label {
  color: #626673;
  text-align: right;
  display: inline-block;
}
.change-label-calss /deep/ .el-date-range-picker__time-header {
  display: none !important;
}
.change-label-calss /deep/ {
  // margin-right: 40px !important;
  margin-bottom: 10px;
}
/deep/ .change-label-calss,
/deep/ .el-form-item__label {
  height: 36px;
  line-height: 36px !important;
}

/deep/ .el-input__icon {
  line-height: 32px;
}


// 按钮
.select-con /deep/ .el-button {
  padding: 7px 22px;
  margin: 0;
}


/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
/* 时间选择器 : input 高度 */
/deep/ .el-form-item__content {
  height: 36px;
}
/* 缴费日期搜索框宽高设置 */
/deep/ .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange{
  width: 260px;
  height: 36px;
  padding-top: 2px;
  line-height: 36px !important;
  padding-right: 0px !important;
}

/deep/ .el-date-editor.el-range-editor.el-input__inner.el-date-editor--datetimerange {
  width: 260px;
  height: 36px;
  padding-top: 2px;
  line-height: 36px !important;
  padding-right: 0px !important;
}

/* 缴费日期中间"至"字的样式 */
/deep/ .el-range-separator {
  line-height: 18px !important;
  font-size: 13px !important;
  width: 5%;
  margin-right:20px!important;
  color: #45494d !important;
  margin-left:8px!important;
}
/* 缴费日期最左侧图标位置 */
/deep/ .el-input__icon.el-range__icon.el-icon-date,/deep/ .el-input__icon.el-range__icon.el-icon-time {
  box-sizing: border-box;
  margin-right:8px;
  display: flex;
  justify-content: row;
  align-items: center;
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
    width: 200px;
    height: 36px;
    line-height: 18px;
}

/deep/ .el-date-range-picker__editor.el-input.el-input--small{
  width:144px!important;
  .el-input__inner{
    width:144px!important;
  }
}


/deep/ .el-form-item__content {
  width: 200px;
  .el-input {
    width:200px;
  }
}

.el-form-item.buttons {
  position: absolute;
  right: 0px;
  z-index: 999;
  margin-right: 0px!important;
  /deep/ .el-form-item__content {
    max-width: 180px;
  }
}
.el-form-item.buttons.short {
  position: absolute;
  right: 0px;
  z-index: 999;
  margin-right: 0px!important;
  /deep/ .el-form-item__content {
    max-width: 90px;
  }
}
.el-form-item.site-button.short {
  // position: absolute;
  // right: 0px;
  margin-right: 0px!important;
  /deep/ .el-form-item__content {
    width: 90px;
  }
}

.el-form-item.site-button {
  // position: absolute;
  // right: 0px;
  margin-right: 0px!important;
  /deep/ .el-form-item__content {
    min-width: 0;
    max-width: 180px;
  }
}

// 下拉框
.el-select {
  width: 200px;
  /deep/ .el-input.el-input--suffix {
    width: 100%;
  }
  /deep/ .el-input__inner {
    width: 200px;
  }
}
.input-interval {
  display: flex;
  /deep/ .el-input {
    width: 80px;
  }
  /deep/ .el-input__inner {
    text-align: center !important;
    width: 80px;
    padding-left: 20px !important;
    padding-right: 20px!important;
  }
}

</style>
